import axios from 'axios';
import React, { useState } from 'react';
import FacebookLogin from 'react-facebook-login';

// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { BsApple, BsFacebook } from 'react-icons/bs';
import { FaFacebook } from 'react-icons/fa';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { globalEnv } from '../config/baseConfig';
import { LoginAuthAction } from '../redux/actions/authAction';
import { SetNotificationAction } from '../redux/actions/notificationAction';
import { stateNotificationsEnum } from './Utils/notification';

function FacebookLoginComponent() {
	const [login, setLogin] = useState(false);
	const [data, setData] = useState({});
	const [picture, setPicture] = useState('');
	const [response, setResponse] = useState<any>('');

	const responseFacebook = (response: any) => {
		console.log(response);
		// Login failed
		if (response.status === 'unknown') {
			alert('Login failed!');
			setLogin(false);
			return false;
		}
		setData(response);
		setPicture(response.picture.data.url);
		if (response.accessToken) {
			setResponse(response);
			// setLogin(true);
			loginSubmit.mutate();
		} else {
			setLogin(false);
		}
	};
	const logout = () => {
		setLogin(false);
		setData({});
		setPicture('');
	};

	const loginReq = async () => {
		const params = new URLSearchParams();
		params.append('tokenId', response.accessToken);
		params.append('deviceId', '000000');
		const { data: res } = await axios.post(
			globalEnv.BASE_URL + '/admin/user/admin-facebook-auth/',
			params
		);
		return res;
	};

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const loginSubmit = useMutation(loginReq, {
		onSuccess: (data) => {
			dispatch(LoginAuthAction(data));
			navigate(`../home/documents`);
		},
		onError: (error) => {
			setLogin(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: 'User is not an admin, please contact an admin.'
				})
			);
		}

		// onSettled: () => {
		// 	queryClient.invalidateQueries('create');
		// }
	});

	return (
		<div>
			{!login && (
				<FacebookLogin
					appId="427102462256460"
					autoLoad={false}
					fields="name,email,picture"
					scope="public_profile,email,user_friends"
					callback={responseFacebook}
					icon="fa-facebook"
					// render={(renderProps) => (
					// 	<button
					// 		onClick={(e) => {
					// 			console.trace();
					// 		}}
					// 	>
					// 		<BsFacebook className="m-auto w-10 h-10 bg-blue-700 rounded-full" />
					// 	</button>
					// )}
				/>
			)}

			{login && (
				<div>
					<div>
						{/* <img className="rounded" src={picture} alt="Profile" />
						<h5 className="card-title">{data.name}</h5>
						<p className="card-text">Email ID: {data.email}</p> */}
						<a href="#" className="btn btn-danger btn-sm" onClick={logout}>
							Logout
						</a>
					</div>
				</div>
			)}
		</div>
	);
}

export default FacebookLoginComponent;
